module.exports = __webpack_public_path__ + "img/49.6b2f86a9.jpg";